import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('events', ['events', 'b2b', 'eventsFiltered', 'actualEvent', 'pending']),
  },
  methods: {
    ...mapActions('events', ['getEvents', 'getActualEvent']),
  },
  created() {
    if (!this.pending.actualEvent) {
      this.getActualEvent()
    }

    if (this.pending.events) return
    if (!this.events.length || this.eventsFiltered) {
      this.getEvents()
    }
  },
}
